// Accepts both promo (Back order / Original) and instore (Week / Opening /
// Relocation) type names. Instore hues mirror the flow-pill bucket colors
// (Week=purple, Opening=indigo, Relocation=teal).
export function getOrderTypeColor(ordertypeName?: string): {
  liteBg?: string;
  border: string;
  text: string;
  ring: string;
  fill: string;
  bg: string;
} {
  switch (ordertypeName) {
    case "Back order":
      return {
        liteBg: "bg-amber-50",
        border: "border-amber-500",
        text: "text-amber-900",
        ring: "ring-amber-800",
        fill: "fill-amber-600",
        bg: "bg-amber-200",
      };
    case "Original":
      return {
        liteBg: "bg-emerald-100",
        border: "border-emerald-500",
        text: "text-emerald-900",
        ring: "ring-emerald-500",
        fill: "fill-emerald-500",
        bg: "bg-emerald-200",
      };
    case "Week":
      return {
        liteBg: "bg-purple-100",
        border: "border-purple-500",
        text: "text-purple-900",
        ring: "ring-purple-500",
        fill: "fill-purple-500",
        bg: "bg-purple-200",
      };
    case "Relocation":
      return {
        liteBg: "bg-teal-100",
        border: "border-teal-500",
        text: "text-teal-900",
        ring: "ring-teal-500",
        fill: "fill-teal-500",
        bg: "bg-teal-200",
      };
    case "Opening":
      return {
        liteBg: "bg-indigo-100",
        border: "border-indigo-500",
        text: "text-indigo-900",
        ring: "ring-indigo-500",
        fill: "fill-indigo-500",
        bg: "bg-indigo-200",
      };
    /// More here if needed
    default:
      return {
        liteBg: "bg-gray-50",
        border: "border-gray-500",
        text: "text-gray-900",
        ring: "ring-gray-500",
        fill: "fill-gray-500",
        bg: "bg-gray-200",
      };
  }
}
